// import React, { useEffect, useState } from "react";
// import { Modal, Button, Table, Form, Pagination } from "react-bootstrap";
// import { FaTrash, FaSearch } from "react-icons/fa";
// import { Pencil } from "lucide-react";
// import Swal from "sweetalert2";
// import axios from "axios";
// import Select from "react-select";

// const CourseAssignment = () => {
//   const [assignments, setAssignments] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [occupations, setOccupations] = useState([]);
//   const [selectedOccupation, setSelectedOccupation] = useState(null);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [userSearchTerm, setUserSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [assignmentsPerPage] = useState(10);
//   const [isTableLoading, setIsTableLoading] = useState(false);
//   const [isModalLoading, setIsModalLoading] = useState(false);

//   const theme = {
//     primary: "#7366ff",
//     secondary: "#ff8c00",
//     light: "#f8f9fa",
//     dark: "#343a40",
//     text: "#2c3e50",
//     muted: "#6c757d",
//   };

//   const token = localStorage.getItem("jwttoken");

//   const fetchAssignedCourses = async () => {
//     try {
//       setIsTableLoading(true);
//       const response = await axios.get(
//         "https://kaasbackend.vetrinahealthcare.com/lms/admin/recent-course-assignments/",
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const transformedAssignments = response.data.assignments.map(
//         (assignment) => ({
//           id: `${assignment.user_id}-${assignment.course_id}`,
//           student: assignment.user_id,
//           course: assignment.course_id,
//           studentDetails: {
//             user_id: assignment.user_id,
//             first_name: assignment.user_name.split(" ")[0],
//             last_name: assignment.user_name.split(" ").slice(1).join(" "),
//             email: assignment.email,
//           },
//           courseDetails: {
//             course_id: assignment.course_id,
//             title: assignment.course_name,
//           },
//           enrolled_on: assignment.enrolled_on,
//           is_approved: assignment.is_approved,
//           price: assignment.price,
//         })
//       );

//       setAssignments(transformedAssignments);
//     } catch (err) {
//       console.error("Failed to fetch assignments:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to fetch course assignments",
//         confirmButtonColor: theme.primary,
//       });
//     } finally {
//       setIsTableLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setIsTableLoading(true);

//         const usersResponse = await axios.get(
//           "https://kaasbackend.vetrinahealthcare.com/lms/all-users/",
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setUsers(usersResponse.data.users || []);
//         setFilteredUsers(usersResponse.data.users || []);

//         const coursesResponse = await axios.get(
//           "https://kaasbackend.vetrinahealthcare.com/lms/courses/",
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setCourses(coursesResponse.data.courses || []);

//         const occupationsResponse = await axios.get(
//           "https://kaasbackend.vetrinahealthcare.com/master/occupations/",
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setOccupations(occupationsResponse.data || []);

//         await fetchAssignedCourses();
//       } catch (err) {
//         console.error("API error:", err);
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to fetch data",
//           confirmButtonColor: theme.primary,
//         });
//       } finally {
//         setIsTableLoading(false);
//       }
//     };

//     fetchData();
//   }, [token]);

//   useEffect(() => {
//     let usersByOccupation = users;
//     if (selectedOccupation) {
//       usersByOccupation = users.filter((user) => {
//         const userOccupation = user.occupation
//           ? user.occupation.toString().toLowerCase()
//           : "";
//         const selectedOccupationLower = selectedOccupation.value.toLowerCase();
//         return userOccupation === selectedOccupationLower;
//       });
//     }

//     if (userSearchTerm) {
//       const lowercasedFilter = userSearchTerm.toLowerCase();
//       const filteredData = usersByOccupation.filter((user) => {
//         const fullName = `${user.first_name || ""} ${user.middle_name || ""} ${
//           user.last_name || ""
//         }`.toLowerCase();
//         const email = (user.email || "").toLowerCase();
//         return (
//           fullName.includes(lowercasedFilter) ||
//           email.includes(lowercasedFilter)
//         );
//       });
//       setFilteredUsers(filteredData);
//     } else {
//       setFilteredUsers(usersByOccupation);
//     }
//   }, [selectedOccupation, users, userSearchTerm]);

//   const getOccupationName = (occupation) => {
//     if (!occupation) return "Not specified";
//     if (typeof occupation === "number") {
//       const occupationObj = occupations.find((o) => o.id === occupation);
//       return occupationObj ? occupationObj.name : occupation;
//     }
//     return occupation;
//   };

//   const getUserDisplay = (user) => {
//     const occupationName = getOccupationName(user.occupation);
//     let details = "";

//     if (
//       occupationName.toLowerCase().includes("company") ||
//       occupationName.toLowerCase().includes("employee")
//     ) {
//       details = [
//         user.employee_designation || "Designation not specified",
//         user.employee_division || "Division not specified",
//         user.employee_subdivision || "Sub-division not specified",
//       ].join(", ");
//     } else {
//       details = user.district;
//     }

//     return `${user.first_name} ${user.middle_name || ""} ${
//       user.last_name
//     } (${details})`;
//   };

//   const getCourseDisplay = (course) => {
//     return `${course.course_id}.${course.title} (${
//       course.instructor?.name || "Instructor not specified"
//     })`;
//   };

//   const getUserName = (userId) => {
//     const user = users.find((u) => u.user_id.toString() === userId.toString());
//     return user ? getUserDisplay(user) : `User ID: ${userId}`;
//   };

//   const handleAssign = async () => {
//     if (!selectedUsers.length || !selectedCourse) {
//       Swal.fire({
//         icon: "warning",
//         title: "Incomplete Selection",
//         text: "Please select at least one user and a course",
//         confirmButtonColor: theme.primary,
//       });
//       return;
//     }

//     try {
//       setIsModalLoading(true);

//       const payload = {
//         user_ids: selectedUsers.map((id) => Number(id)),
//         course_id: Number(selectedCourse.value),
//       };

//       const response = await axios.post(
//         "https://kaasbackend.vetrinahealthcare.com/lms/admin/assign-course/",
//         payload,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       if (response.status >= 200 && response.status < 300) {
//         const apiResponse = response.data;
//         await fetchAssignedCourses();

//         let successMessage =
//           apiResponse.message || "Course assigned successfully";

//         if (
//           apiResponse.already_enrolled &&
//           apiResponse.already_enrolled.length > 0
//         ) {
//           successMessage += `\n\nNote: ${apiResponse.already_enrolled.length} user(s) were already enrolled.`;
//         }

//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: successMessage,
//           confirmButtonColor: theme.primary,
//         });

//         setSelectedOccupation(null);
//         setSelectedUsers([]);
//         setSelectedCourse(null);
//         setShowModal(false);
//         setUserSearchTerm("");
//       } else {
//         throw new Error(response.data.message || "Failed to assign course");
//       }
//     } catch (err) {
//       console.error("Assignment error:", err);
//       let errorMessage = "Failed to assign course";

//       if (err.response) {
//         errorMessage =
//           err.response.data.message ||
//           err.response.data.error ||
//           err.response.statusText;
//       } else if (err.request) {
//         errorMessage = "No response received from server";
//       } else {
//         errorMessage = err.message;
//       }

//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: errorMessage,
//         confirmButtonColor: theme.primary,
//       });
//     } finally {
//       setIsModalLoading(false);
//     }
//   };

//   const handleEdit = (item) => {
//     const user = users.find(
//       (u) => u.user_id.toString() === item.student.toString()
//     );
//     const occupationValue = user?.occupation || "";
//     const courseValue = item.course;

//     const occupationOption = {
//       value: occupationValue,
//       label: getOccupationName(occupationValue),
//     };
//     const courseOption = {
//       value: courseValue,
//       label:
//         courses.find((c) => Number(c.course_id) === Number(courseValue))
//           ?.title || `Course ID: ${courseValue}`,
//     };

//     setSelectedOccupation(occupationOption);
//     setSelectedCourse(courseOption);
//     setSelectedUsers([item.student.toString()]);
//     setEditingId(item.id);
//     setShowModal(true);
//   };

//   const handleDelete = async (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "This will delete the assignment.",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: theme.primary,
//       cancelButtonColor: theme.secondary,
//       confirmButtonText: "Yes, delete it",
//     }).then(async (res) => {
//       if (res.isConfirmed) {
//         try {
//           setIsTableLoading(true);
//           await axios.delete(
//             `https://kaasbackend.vetrinahealthcare.com/lms/admin/recent-course-assignments/${id}/`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           await fetchAssignedCourses();

//           Swal.fire({
//             title: "Deleted!",
//             text: "Assignment removed.",
//             icon: "success",
//             confirmButtonColor: theme.primary,
//           });
//         } catch (err) {
//           console.error("Delete error:", err);
//           Swal.fire({
//             icon: "error",
//             title: "Error",
//             text: "Failed to delete assignment",
//             confirmButtonColor: theme.primary,
//           });
//         } finally {
//           setIsTableLoading(false);
//         }
//       }
//     });
//   };

//   const filteredAssignments = assignments.filter((a) => {
//     const userName = getUserName(a.student).toLowerCase();
//     const courseTitle =
//       courses.find((c) => c.course_id === a.course)?.title.toLowerCase() || "";
//     return (
//       userName.includes(searchTerm.toLowerCase()) ||
//       courseTitle.includes(searchTerm.toLowerCase())
//     );
//   });

//   const indexOfLastAssignment = currentPage * assignmentsPerPage;
//   const indexOfFirstAssignment = indexOfLastAssignment - assignmentsPerPage;
//   const currentAssignments = filteredAssignments.slice(
//     indexOfFirstAssignment,
//     indexOfLastAssignment
//   );
//   const totalPages = Math.ceil(filteredAssignments.length / assignmentsPerPage);

//   const allOccupations = [
//     ...new Set([
//       ...occupations.map((occ) => occ.name),
//       ...users.map((u) => u.occupation).filter(Boolean),
//     ]),
//   ]
//     .filter(Boolean)
//     .map((occupation) => ({
//       value: occupation,
//       label: getOccupationName(occupation),
//     }));

//   const courseOptions = courses.map((course) => ({
//     value: course.course_id,
//     label: getCourseDisplay(course),
//   }));

//   return (
//     <div className="container py-4">
//       <style>
//         {`
//           .vetrina-modal .modal-dialog {
//             max-width: 500px;
//             width: 100%;
//             height: 100%;
//             // margin: 1.75rem auto;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             max-height: 90vh;
//           }
//           .vetrina-modal .modal-content {
//             border: none;
//             border-radius: 12px;
//             box-shadow: 0 10px 30px rgba(0,0,0,0.15);
//             max-height: 85vh;
//             display: flex;
//             flex-direction: column;
//           }
//           .vetrina-modal .modal-header {
//             background: linear-gradient(135deg, ${theme.primary}, ${theme.secondary});
//             color: white;
//             border-bottom: none;
//             padding: 1rem 1.5rem;
//           }
//           .vetrina-modal .modal-header .btn-close {
//             filter: invert(1) grayscale(100%) brightness(200%);
//           }
//           .vetrina-modal .modal-body {
//             padding: 1.5rem;
//             overflow-y: auto;
//           }
//           .vetrina-modal .modal-footer {
//             border-top: 1px solid #eee;
//             padding: 1rem 1.5rem;
//             background: #f9f9f9;
//           }
//           .user-list-container {
//             max-height: 200px;
//             overflow-y: auto;
//             padding: 5px;
//             border-radius: 8px;
//             border: 1px solid #eee;
//             margin-bottom: 10px;
//           }
//           .user-card {
//             display: flex;
//             align-items: center;
//             padding: 8px 10px;
//             margin-bottom: 8px;
//             border-radius: 6px;
//             border: 1px solid #eee;
//             transition: all 0.2s;
//             cursor: pointer;
//             background: white;
//           }
//           .user-card:hover {
//             border-color: ${theme.primary};
//             box-shadow: 0 3px 10px rgba(115, 102, 255, 0.1);
//           }
//           .user-card.selected {
//             border-color: ${theme.primary};
//             background: rgba(115, 102, 255, 0.05);
//           }
//           .user-card .user-info {
//             margin-left: 10px;
//             flex-grow: 1;
//           }
//           .user-card .user-name {
//             font-weight: 500;
//             color: ${theme.text};
//             font-size: 0.9rem;
//           }
//           .user-card .user-details {
//             font-size: 0.8rem;
//             color: ${theme.muted};
//           }
//           .table-container {
//             background: white;
//             border-radius: 12px;
//             box-shadow: 0 2px 15px rgba(0,0,0,0.05);
//             padding: 15px;
//             margin-bottom: 15px;
//             position: relative;
//             min-height: 300px;
//           }
//           .table-loading-overlay {
//             position: absolute;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(255, 255, 255, 0.8);
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 10;
//             border-radius: 12px;
//           }
//           .search-container {
//             position: relative;
//             width: 300px;
//           }
//           .search-icon {
//             position: absolute;
//             left: 12px;
//             top: 10px;
//             color: ${theme.muted};
//           }
//           .search-input {
//             padding-left: 35px;
//             border-radius: 8px;
//             border: 1px solid #ddd;
//             height: 38px;
//             width: 100%;
//             transition: all 0.3s;
//           }
//           .btn-vetrina-primary {
//             background: linear-gradient(135deg, ${theme.primary}, ${theme.secondary});
//             border: none;
//             color: white;
//             font-weight: 500;
//             border-radius: 8px;
//             padding: 8px 18px;
//             transition: all 0.2s;
//           }
//         `}
//       </style>

//       <h3
//         className="mb-3 text-center"
//         style={{ color: theme.text, fontWeight: "600" }}
//       >
//         Course Assignments
//       </h3>

//       <div className="d-flex justify-content-between mb-3 align-items-center">
//         <div className="search-container">
//           <FaSearch className="search-icon" />
//           <input
//             type="text"
//             placeholder="Search assignments..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//         </div>
//         <Button
//           onClick={() => {
//             setEditingId(null);
//             setSelectedOccupation(null);
//             setSelectedUsers([]);
//             setSelectedCourse(null);
//             setUserSearchTerm("");
//             setShowModal(true);
//           }}
//           className="btn-vetrina-primary"
//           disabled={isTableLoading}
//         >
//           + Assign Course
//         </Button>
//       </div>

//       <div className="table-container">
//         {isTableLoading && (
//           <div className="table-loading-overlay">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </div>
//         )}

//         <Table hover responsive className="mb-0">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>User</th>
//               <th>Course</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentAssignments.length > 0 ? (
//               currentAssignments.map((item, idx) => (
//                 <tr key={item.id}>
//                   <td style={{ color: theme.muted }}>
//                     {indexOfFirstAssignment + idx + 1}
//                   </td>
//                   <td>{getUserName(item.student)}</td>
//                   <td>
//                     {courses.find(
//                       (c) => Number(c.course_id) === Number(item.course)
//                     )?.title || `Course ID: ${item.course}`}
//                   </td>
//                   <td>
//                     <div className="d-flex">
//                       <Button
//                         variant="link"
//                         onClick={() => handleEdit(item)}
//                         className="text-primary p-0 me-2"
//                         title="Edit"
//                         disabled={isTableLoading}
//                       >
//                         <Pencil size={18} />
//                       </Button>
//                       <Button
//                         variant="link"
//                         onClick={() => handleDelete(item.id)}
//                         className="text-danger p-0"
//                         title="Delete"
//                         disabled={isTableLoading}
//                       >
//                         <FaTrash size={18} />
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan="4"
//                   className="text-center py-4"
//                   style={{ color: theme.muted }}
//                 >
//                   {searchTerm
//                     ? "No matching assignments found"
//                     : "No assignments created yet"}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>

//         {filteredAssignments.length > assignmentsPerPage && (
//           <div className="d-flex justify-content-center mt-3">
//             <Pagination>
//               <Pagination.Prev
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1 || isTableLoading}
//               />
//               {Array.from({ length: totalPages }, (_, i) => (
//                 <Pagination.Item
//                   key={i + 1}
//                   active={i + 1 === currentPage}
//                   onClick={() => setCurrentPage(i + 1)}
//                   disabled={isTableLoading}
//                   activeLabel=""
//                   style={{
//                     backgroundColor:
//                       i + 1 === currentPage ? theme.primary : "transparent",
//                     borderColor:
//                       i + 1 === currentPage ? theme.primary : "#dee2e6",
//                     color: i + 1 === currentPage ? "white" : theme.text,
//                     margin: "0 3px",
//                     borderRadius: "6px",
//                   }}
//                 >
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages || isTableLoading}
//               />
//             </Pagination>
//           </div>
//         )}
//       </div>

//       <Modal
//         show={showModal}
//         onHide={() => !isModalLoading && setShowModal(false)}
//         backdrop="static"
//         keyboard={false}
//         className="vetrina-modal"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editingId ? "Edit Assignment" : "Create New Assignment"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {isModalLoading && (
//             <div className="text-center py-3">
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           )}

//           {!isModalLoading && (
//             <Form>
//               <Form.Group className="mb-3">
//                 <Form.Label style={{ fontWeight: "500", fontSize: "0.9rem" }}>
//                   Select Occupation
//                 </Form.Label>
//                 <Select
//                   options={allOccupations}
//                   value={selectedOccupation}
//                   onChange={(option) => {
//                     setSelectedOccupation(option);
//                     setSelectedUsers([]);
//                   }}
//                   isClearable
//                   placeholder="All Occupations"
//                   menuPosition="fixed"
//                   menuPlacement="auto"
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label
//                   style={{
//                     fontWeight: "500",
//                     marginBottom: "8px",
//                     fontSize: "0.9rem",
//                   }}
//                 >
//                   Select Users{" "}
//                   {selectedOccupation &&
//                     `(Filtered by: ${selectedOccupation.label})`}
//                 </Form.Label>
//                 <div className="search-container mb-2">
//                   <FaSearch className="search-icon" />
//                   <input
//                     type="text"
//                     placeholder="Search users by name or email..."
//                     value={userSearchTerm}
//                     onChange={(e) => setUserSearchTerm(e.target.value)}
//                     className="search-input"
//                   />
//                 </div>
//                 <div className="user-list-container">
//                   {filteredUsers.length > 0 ? (
//                     filteredUsers.map((user) => (
//                       <div
//                         key={user.user_id}
//                         className={`user-card ${
//                           selectedUsers.includes(user.user_id.toString())
//                             ? "selected"
//                             : ""
//                         }`}
//                         onClick={() => {
//                           if (!isModalLoading) {
//                             if (
//                               selectedUsers.includes(user.user_id.toString())
//                             ) {
//                               setSelectedUsers(
//                                 selectedUsers.filter(
//                                   (id) => id !== user.user_id.toString()
//                                 )
//                               );
//                             } else {
//                               setSelectedUsers([
//                                 ...selectedUsers,
//                                 user.user_id.toString(),
//                               ]);
//                             }
//                           }
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: "32px",
//                             height: "32px",
//                             borderRadius: "50%",
//                             background: `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})`,
//                             color: "white",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             fontWeight: "600",
//                             fontSize: "0.8rem",
//                           }}
//                         >
//                           {`${user.user_id}`}
//                         </div>
//                         <div className="user-info">
//                           <div className="user-name">
//                             {`${user.first_name} ${user.middle_name || ""} ${
//                               user.last_name
//                             } •${user.employee_headquarter}`}
//                           </div>
//                           <div className="user-details">
//                             {user.email}
//                             {user.employee_designation &&
//                               ` • ${user.employee_designation}`}
//                             {user.employee_division &&
//                               ` • ${user.employee_division}`}
//                             {user.employee_subdivision &&
//                               ` • ${user.employee_subdivision}`}
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div
//                       className="text-center py-2"
//                       style={{ color: theme.muted }}
//                     >
//                       {userSearchTerm || selectedOccupation
//                         ? "No users found for this filter"
//                         : "No users available"}
//                     </div>
//                   )}
//                 </div>
//               </Form.Group>

//               <Form.Group controlId="courseSelect" className="mb-3">
//                 <Form.Label style={{ fontWeight: "500", fontSize: "0.9rem" }}>
//                   Select Course
//                 </Form.Label>
//                 <Select
//                   options={courseOptions}
//                   value={selectedCourse}
//                   onChange={setSelectedCourse}
//                   isClearable
//                   placeholder="Select a course"
//                   menuPosition="fixed"
//                   menuPlacement="auto"
//                 />
//               </Form.Group>
//             </Form>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="light"
//             onClick={() => setShowModal(false)}
//             disabled={isModalLoading}
//             size="sm"
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleAssign}
//             className="btn-vetrina-primary"
//             disabled={
//               isModalLoading || !selectedUsers.length || !selectedCourse
//             }
//             size="sm"
//           >
//             {isModalLoading ? "Processing..." : editingId ? "Update" : "Assign"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default CourseAssignment;\

import React, { useEffect, useState } from "react";
import { Modal, Button, Table, Form, Pagination } from "react-bootstrap";
import { FaTrash, FaSearch, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Pencil } from "lucide-react";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";

const CourseAssignment = () => {
  const [assignments, setAssignments] = useState([]);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [selectedOccupation, setSelectedOccupation] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [assignmentsPerPage] = useState(10);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const theme = {
    primary: "#7366ff",
    secondary: "#ff8c00",
    light: "#f8f9fa",
    dark: "#343a40",
    text: "#2c3e50",
    muted: "#6c757d",
  };

  const token = localStorage.getItem("jwttoken");

  const fetchAssignedCourses = async () => {
    try {
      setIsTableLoading(true);
      const response = await axios.get(
        "https://kaasbackend.vetrinahealthcare.com/lms/admin/recent-course-assignments/",
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const transformedAssignments = response.data.assignments.map(
        (assignment) => ({
          id: `${assignment.user_id}-${assignment.course_id}`,
          student: assignment.user_id,
          course: assignment.course_id,
          studentDetails: {
            user_id: assignment.user_id,
            first_name: assignment.user_name.split(" ")[0],
            last_name: assignment.user_name.split(" ").slice(1).join(" "),
            email: assignment.email,
          },
          courseDetails: {
            course_id: assignment.course_id,
            title: assignment.course_name,
          },
          enrolled_on: assignment.enrolled_on,
          is_approved: assignment.is_approved,
          price: assignment.price,
        })
      );

      setAssignments(transformedAssignments);
    } catch (err) {
      console.error("Failed to fetch assignments:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch course assignments",
        confirmButtonColor: theme.primary,
      });
    } finally {
      setIsTableLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsTableLoading(true);

        const usersResponse = await axios.get(
          "https://kaasbackend.vetrinahealthcare.com/lms/all-users/",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUsers(usersResponse.data.users || []);
        setFilteredUsers(usersResponse.data.users || []);

        const coursesResponse = await axios.get(
          "https://kaasbackend.vetrinahealthcare.com/lms/courses/",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourses(coursesResponse.data.courses || []);

        const occupationsResponse = await axios.get(
          "https://kaasbackend.vetrinahealthcare.com/master/occupations/",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setOccupations(occupationsResponse.data || []);

        await fetchAssignedCourses();
      } catch (err) {
        console.error("API error:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch data",
          confirmButtonColor: theme.primary,
        });
      } finally {
        setIsTableLoading(false);
      }
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    let usersByOccupation = users;
    if (selectedOccupation) {
      usersByOccupation = users.filter((user) => {
        const userOccupation = user.occupation
          ? user.occupation.toString().toLowerCase()
          : "";
        const selectedOccupationLower = selectedOccupation.value.toLowerCase();
        return userOccupation === selectedOccupationLower;
      });
    }

    if (userSearchTerm) {
      const lowercasedFilter = userSearchTerm.toLowerCase();
      const filteredData = usersByOccupation.filter((user) => {
        const fullName = `${user.first_name || ""} ${user.middle_name || ""} ${user.last_name || ""
          }`.toLowerCase();
        const email = (user.email || "").toLowerCase();
        return (
          fullName.includes(lowercasedFilter) ||
          email.includes(lowercasedFilter)
        );
      });
      setFilteredUsers(filteredData);
    } else {
      setFilteredUsers(usersByOccupation);
    }
  }, [selectedOccupation, users, userSearchTerm]);

  const getOccupationName = (occupation) => {
    if (!occupation) return "Not specified";
    if (typeof occupation === "number") {
      const occupationObj = occupations.find((o) => o.id === occupation);
      return occupationObj ? occupationObj.name : occupation;
    }
    return occupation;
  };

  const getUserDisplay = (user) => {
    const occupationName = getOccupationName(user.occupation);
    let details = "";

    if (
      occupationName.toLowerCase().includes("company") ||
      occupationName.toLowerCase().includes("employee")
    ) {
      details = [
        user.employee_designation || "Designation not specified",
        user.employee_division || "Division not specified",
        user.employee_subdivision || "Sub-division not specified",
      ].join(", ");
    } else {
      details = user.district;
    }

    return `${user.first_name} ${user.middle_name || ""} ${user.last_name
      } (${details})`;
  };

  const getCourseDisplay = (course) => {
    return `${course.course_id}.${course.title} (${course.instructor?.name || "Instructor not specified"
      })`;
  };

  const getUserName = (userId) => {
    const user = users.find((u) => u.user_id.toString() === userId.toString());
    return user ? getUserDisplay(user) : `User ID: ${userId}`;
  };

  const handleAssign = async () => {
    if (!selectedUsers.length || !selectedCourse) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Selection",
        text: "Please select at least one user and a course",
        confirmButtonColor: theme.primary,
      });
      return;
    }

    try {
      setIsModalLoading(true);

      const payload = {
        user_ids: selectedUsers.map((id) => Number(id)),
        course_id: Number(selectedCourse.value),
      };

      const response = await axios.post(
        "https://kaasbackend.vetrinahealthcare.com/lms/admin/assign-course/",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status >= 200 && response.status < 300) {
        const apiResponse = response.data;
        await fetchAssignedCourses();

        let successMessage =
          apiResponse.message || "Course assigned successfully";

        if (
          apiResponse.already_enrolled &&
          apiResponse.already_enrolled.length > 0
        ) {
          successMessage += `\n\nNote: ${apiResponse.already_enrolled.length} user(s) were already enrolled.`;
        }

        Swal.fire({
          icon: "success",
          title: "Success",
          text: successMessage,
          confirmButtonColor: theme.primary,
        });

        setSelectedOccupation(null);
        setSelectedUsers([]);
        setSelectedCourse(null);
        setShowModal(false);
        setUserSearchTerm("");
      } else {
        throw new Error(response.data.message || "Failed to assign course");
      }
    } catch (err) {
      console.error("Assignment error:", err);
      let errorMessage = "Failed to assign course";

      if (err.response) {
        errorMessage =
          err.response.data.message ||
          err.response.data.error ||
          err.response.statusText;
      } else if (err.request) {
        errorMessage = "No response received from server";
      } else {
        errorMessage = err.message;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        confirmButtonColor: theme.primary,
      });
    } finally {
      setIsModalLoading(false);
    }
  };

  const handleEdit = (item) => {
    const user = users.find(
      (u) => u.user_id.toString() === item.student.toString()
    );
    const occupationValue = user?.occupation || "";
    const courseValue = item.course;

    const occupationOption = {
      value: occupationValue,
      label: getOccupationName(occupationValue),
    };
    const courseOption = {
      value: courseValue,
      label:
        courses.find((c) => Number(c.course_id) === Number(courseValue))
          ?.title || `Course ID: ${courseValue}`,
    };

    setSelectedOccupation(occupationOption);
    setSelectedCourse(courseOption);
    setSelectedUsers([item.student.toString()]);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleDelete = async (courseId, userId) => {
    Swal.fire({
      title: "Remove user from course?",
      text: "This user will be unenrolled from the course.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: theme.primary,
      cancelButtonColor: theme.secondary,
      confirmButtonText: "Yes, remove",
    }).then(async (res) => {
      if (res.isConfirmed) {
        try {
          setIsTableLoading(true);

          await axios.delete(
            `https://kaasbackend.vetrinahealthcare.com/lms/courses/${courseId}/remove-user/${userId}/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          await fetchAssignedCourses();

          Swal.fire({
            icon: "success",
            title: "Removed",
            text: "User removed from course successfully.",
            confirmButtonColor: theme.primary,
          });
        } catch (err) {
          console.error("Remove user error:", err);

          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              err.response?.data?.message ||
              "Failed to remove user from course",
            confirmButtonColor: theme.primary,
          });
        } finally {
          setIsTableLoading(false);
        }
      }
    });
  };


  const filteredAssignments = assignments.filter((a) => {
    const userName = getUserName(a.student).toLowerCase();
    const courseTitle =
      courses.find((c) => c.course_id === a.course)?.title.toLowerCase() || "";
    return (
      userName.includes(searchTerm.toLowerCase()) ||
      courseTitle.includes(searchTerm.toLowerCase())
    );
  });

  const indexOfLastAssignment = currentPage * assignmentsPerPage;
  const indexOfFirstAssignment = indexOfLastAssignment - assignmentsPerPage;
  const currentAssignments = filteredAssignments.slice(
    indexOfFirstAssignment,
    indexOfLastAssignment
  );
  const totalPages = Math.ceil(filteredAssignments.length / assignmentsPerPage);

  // Calculate visible page numbers
  const getVisiblePages = () => {
    const visiblePages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages is less than or equal to maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Always show first page
      visiblePages.push(1);

      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Adjust if we're near the beginning
      if (currentPage <= 3) {
        endPage = Math.min(4, totalPages - 1);
      }

      // Adjust if we're near the end
      if (currentPage >= totalPages - 2) {
        startPage = Math.max(2, totalPages - 3);
      }

      // Add ellipsis after first page if needed
      if (startPage > 2) {
        visiblePages.push('ellipsis-start');
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      // Add ellipsis before last page if needed
      if (endPage < totalPages - 1) {
        visiblePages.push('ellipsis-end');
      }

      // Always show last page
      if (totalPages > 1) {
        visiblePages.push(totalPages);
      }
    }

    return visiblePages;
  };

  const allOccupations = [
    ...new Set([
      ...occupations.map((occ) => occ.name),
      ...users.map((u) => u.occupation).filter(Boolean),
    ]),
  ]
    .filter(Boolean)
    .map((occupation) => ({
      value: occupation,
      label: getOccupationName(occupation),
    }));

  const courseOptions = courses
    .filter(course => course.course_active !== false) // Only include courses that are active (true or undefined)
    .map((course) => ({
      value: course.course_id,
      label: getCourseDisplay(course),
    }));

  return (
    <div className="container-fluid py-4 px-3 px-md-4">
      <style>
        {`
          .vetrina-modal .modal-dialog {
            max-width: 500px;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            max-height: 90vh;
          }
          .vetrina-modal .modal-content {
            border: none;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
            max-height: 85vh;
            display: flex;
            flex-direction: column;
          }
          .vetrina-modal .modal-header {
            background: linear-gradient(135deg, ${theme.primary}, ${theme.secondary});
            color: white;
            border-bottom: none;
            padding: 1rem 1.5rem;
          }
          .vetrina-modal .modal-header .btn-close {
            filter: invert(1) grayscale(100%) brightness(200%);
          }
          .vetrina-modal .modal-body {
            padding: 1.5rem;
            overflow-y: auto;
          }
          .vetrina-modal .modal-footer {
            border-top: 1px solid #eee;
            padding: 1rem 1.5rem;
            background: #f9f9f9;
          }
          .user-list-container {
            max-height: 200px;
            overflow-y: auto;
            padding: 5px;
            border-radius: 8px;
            border: 1px solid #eee;
            margin-bottom: 10px;
          }
          .user-card {
            display: flex;
            align-items: center;
            padding: 8px 10px;
            margin-bottom: 8px;
            border-radius: 6px;
            border: 1px solid #eee;
            transition: all 0.2s;
            cursor: pointer;
            background: white;
          }
          .user-card:hover {
            border-color: ${theme.primary};
            box-shadow: 0 3px 10px rgba(115, 102, 255, 0.1);
          }
          .user-card.selected {
            border-color: ${theme.primary};
            background: rgba(115, 102, 255, 0.05);
          }
          .user-card .user-info {
            margin-left: 10px;
            flex-grow: 1;
          }
          .user-card .user-name {
            font-weight: 500;
            color: ${theme.text};
            font-size: 0.9rem;
          }
          .user-card .user-details {
            font-size: 0.8rem;
            color: ${theme.muted};
          }
          
          /* Fixed table container styles */
          .table-container {
            background: white;
            border-radius: 12px;
            box-shadow: 0 2px 15px rgba(0,0,0,0.05);
            padding: 15px;
            margin-bottom: 15px;
            position: relative;
            min-height: 300px;
            overflow-x: auto; /* Added for horizontal scrolling */
            width: 100%; /* Ensure it takes full width */
          }
          
          /* Fix table width */
          .table-container table {
            min-width: 600px; /* Set a minimum width for the table */
            width: 100%;
            margin-bottom: 0;
          }
          
          /* Responsive container */
          .responsive-container {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          
          .table-loading-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
            border-radius: 12px;
          }
          .search-container {
            position: relative;
            width: 300px;
          }
          .search-icon {
            position: absolute;
            left: 12px;
            top: 10px;
            color: ${theme.muted};
          }
          .search-input {
            padding-left: 35px;
            border-radius: 8px;
            border: 1px solid #ddd;
            height: 38px;
            width: 100%;
            transition: all 0.3s;
          }
          .btn-vetrina-primary {
            background: linear-gradient(135deg, ${theme.primary}, ${theme.secondary});
            border: none;
            color: white;
            font-weight: 500;
            border-radius: 8px;
            padding: 8px 18px;
            transition: all 0.2s;
          }
          
          /* Pagination Container with Scroll */
          .pagination-scroll-container {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 5px;
            margin-top: 20px;
          }
          
          .pagination-scroll-container::-webkit-scrollbar {
            height: 6px;
          }
          
          .pagination-scroll-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          
          .pagination-scroll-container::-webkit-scrollbar-thumb {
            background: ${theme.primary}50;
            border-radius: 10px;
          }
          
          .pagination-scroll-container::-webkit-scrollbar-thumb:hover {
            background: ${theme.primary}80;
          }
          
          /* Pagination Styles */
          .pagination-wrapper {
            display: flex;
            justify-content: center;
            min-width: min-content;
            padding: 10px 5px;
          }
          
          .custom-pagination {
            display: flex;
            list-style: none;
            padding: 0;
            margin: 0;
            align-items: center;
            gap: 4px;
          }
          
          .page-item {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .page-link {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 36px;
            height: 36px;
            padding: 0 8px;
            border: 1px solid #dee2e6;
            border-radius: 6px;
            background-color: white;
            color: ${theme.text};
            font-size: 0.9rem;
            font-weight: 500;
            text-decoration: none;
            cursor: pointer;
            transition: all 0.2s;
            user-select: none;
          }
          
          .page-link:hover {
            background-color: #f8f9fa;
            border-color: ${theme.primary};
            color: ${theme.primary};
          }
          
          .page-link.active {
            background: linear-gradient(135deg, ${theme.primary}, ${theme.secondary});
            border-color: ${theme.primary};
            color: white;
          }
          
          .page-link.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background-color: #f8f9fa;
          }
          
          .page-link.ellipsis {
            border: none;
            background: transparent;
            cursor: default;
            min-width: 24px;
          }
          
          .page-link.ellipsis:hover {
            background: transparent;
            border: none;
            color: ${theme.text};
          }
          
          .page-link-arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border: 1px solid #dee2e6;
            border-radius: 6px;
            background-color: white;
            color: ${theme.text};
            font-size: 0.8rem;
            cursor: pointer;
            transition: all 0.2s;
          }
          
          .page-link-arrow:hover {
            background-color: #f8f9fa;
            border-color: ${theme.primary};
            color: ${theme.primary};
          }
          
          .page-link-arrow.disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background-color: #f8f9fa;
          }
          
          /* Media queries for responsiveness */
          @media (max-width: 768px) {
            .container-fluid {
              padding-left: 10px;
              padding-right: 10px;
            }
            
            .d-flex.justify-content-between {
              flex-direction: column;
              gap: 15px;
            }
            
            .search-container {
              width: 100%;
            }
            
            .table-container {
              padding: 10px;
              margin-left: -10px;
              margin-right: -10px;
              border-radius: 8px;
              width: calc(100% + 20px);
            }
            
            .table-container table {
              min-width: 800px; /* Increased for mobile to ensure all columns are visible */
            }
            
            .pagination-scroll-container {
              margin-left: -10px;
              margin-right: -10px;
              padding-left: 10px;
              padding-right: 10px;
            }
            
            .page-link {
              min-width: 32px;
              height: 32px;
              font-size: 0.85rem;
            }
            
            .page-link-arrow {
              width: 32px;
              height: 32px;
            }
          }
          
          @media (max-width: 576px) {
            .vetrina-modal .modal-dialog {
              margin: 10px;
              max-width: calc(100% - 20px);
            }
            
            .modal-body {
              padding: 15px !important;
            }
            
            .user-list-container {
              max-height: 150px;
            }
            
            .btn-vetrina-primary {
              width: 100%;
            }
            
            .page-link {
              min-width: 28px;
              height: 28px;
              padding: 0 6px;
              font-size: 0.8rem;
            }
            
            .page-link-arrow {
              width: 28px;
              height: 28px;
            }
          }
        `}
      </style>

      <h3
        className="mb-4 text-center"
        style={{ color: theme.text, fontWeight: "600" }}
      >
        Course Assignments
      </h3>

      <div className="d-flex justify-content-between mb-4 align-items-center flex-wrap gap-3">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search assignments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <Button
          onClick={() => {
            setEditingId(null);
            setSelectedOccupation(null);
            setSelectedUsers([]);
            setSelectedCourse(null);
            setUserSearchTerm("");
            setShowModal(true);
          }}
          className="btn-vetrina-primary"
          disabled={isTableLoading}
        >
          + Assign Course
        </Button>
      </div>

      <div className="responsive-container">
        <div className="table-container">
          {isTableLoading && (
            <div className="table-loading-overlay">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          <Table hover responsive className="mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>User</th>
                <th>Course</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentAssignments.length > 0 ? (
                currentAssignments.map((item, idx) => (
                  <tr key={item.id}>
                    <td style={{ color: theme.muted }}>
                      {indexOfFirstAssignment + idx + 1}
                    </td>
                    <td>{getUserName(item.student)}</td>
                    <td>
                      {courses.find(
                        (c) => Number(c.course_id) === Number(item.course)
                      )?.title || `Course ID: ${item.course}`}
                    </td>
                    <td>
                      <div className="d-flex">
                        <Button
                          variant="link"
                          onClick={() => handleEdit(item)}
                          className="text-primary p-0 me-2"
                          title="Edit"
                          disabled={isTableLoading}
                        >
                          <Pencil size={18} />
                        </Button>
                        <Button
                          variant="link"
                          onClick={() => handleDelete(item.course, item.student)}
                          className="text-danger p-0"
                          title="Remove User"
                          disabled={isTableLoading}
                        >
                          <FaTrash size={18} />
                        </Button>

                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="text-center py-5"
                    style={{ color: theme.muted }}
                  >
                    {searchTerm
                      ? "No matching assignments found"
                      : "No assignments created yet"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {filteredAssignments.length > assignmentsPerPage && (
            <div className="pagination-scroll-container">
              <div className="pagination-wrapper">
                <div className="custom-pagination">
                  {/* Previous button */}
                  <div className="page-item">
                    <div
                      className={`page-link-arrow ${currentPage === 1 || isTableLoading ? 'disabled' : ''}`}
                      onClick={() => !isTableLoading && currentPage > 1 && setCurrentPage(currentPage - 1)}
                      title="Previous"
                    >
                      <FaChevronLeft size={14} />
                    </div>
                  </div>

                  {/* Page numbers */}
                  {getVisiblePages().map((page, index) => {
                    if (page === 'ellipsis-start' || page === 'ellipsis-end') {
                      return (
                        <div className="page-item" key={`ellipsis-${index}`}>
                          <div className="page-link ellipsis">...</div>
                        </div>
                      );
                    }

                    return (
                      <div className="page-item" key={page}>
                        <div
                          className={`page-link ${currentPage === page ? 'active' : ''} ${isTableLoading ? 'disabled' : ''}`}
                          onClick={() => !isTableLoading && setCurrentPage(page)}
                        >
                          {page}
                        </div>
                      </div>
                    );
                  })}

                  {/* Next button */}
                  <div className="page-item">
                    <div
                      className={`page-link-arrow ${currentPage === totalPages || isTableLoading ? 'disabled' : ''}`}
                      onClick={() => !isTableLoading && currentPage < totalPages && setCurrentPage(currentPage + 1)}
                      title="Next"
                    >
                      <FaChevronRight size={14} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => !isModalLoading && setShowModal(false)}
        backdrop="static"
        keyboard={false}
        className="vetrina-modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editingId ? "Edit Assignment" : "Create New Assignment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isModalLoading && (
            <div className="text-center py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {!isModalLoading && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label style={{ fontWeight: "500", fontSize: "0.9rem" }}>
                  Select Occupation
                </Form.Label>
                <Select
                  options={allOccupations}
                  value={selectedOccupation}
                  onChange={(option) => {
                    setSelectedOccupation(option);
                    setSelectedUsers([]);
                  }}
                  isClearable
                  placeholder="All Occupations"
                  menuPosition="fixed"
                  menuPlacement="auto"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  style={{
                    fontWeight: "500",
                    marginBottom: "8px",
                    fontSize: "0.9rem",
                  }}
                >
                  Select Users{" "}
                  {selectedOccupation &&
                    `(Filtered by: ${selectedOccupation.label})`}
                </Form.Label>
                <div className="search-container mb-2">
                  <FaSearch className="search-icon" />
                  <input
                    type="text"
                    placeholder="Search users by name or email..."
                    value={userSearchTerm}
                    onChange={(e) => setUserSearchTerm(e.target.value)}
                    className="search-input"
                  />
                </div>
                <div className="user-list-container">
                  {filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <div
                        key={user.user_id}
                        className={`user-card ${selectedUsers.includes(user.user_id.toString())
                            ? "selected"
                            : ""
                          }`}
                        onClick={() => {
                          if (!isModalLoading) {
                            if (
                              selectedUsers.includes(user.user_id.toString())
                            ) {
                              setSelectedUsers(
                                selectedUsers.filter(
                                  (id) => id !== user.user_id.toString()
                                )
                              );
                            } else {
                              setSelectedUsers([
                                ...selectedUsers,
                                user.user_id.toString(),
                              ]);
                            }
                          }
                        }}
                      >
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            background: `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})`,
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "600",
                            fontSize: "0.8rem",
                          }}
                        >
                          {`${user.user_id}`}
                        </div>
                        <div className="user-info">
                          <div className="user-name">
                            {`${user.first_name} ${user.middle_name || ""} ${user.last_name
                              } •${user.employee_headquarter}`}
                          </div>
                          <div className="user-details">
                            {user.email}
                            {user.employee_designation &&
                              ` • ${user.employee_designation}`}
                            {user.employee_division &&
                              ` • ${user.employee_division}`}
                            {user.employee_subdivision &&
                              ` • ${user.employee_subdivision}`}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="text-center py-2"
                      style={{ color: theme.muted }}
                    >
                      {userSearchTerm || selectedOccupation
                        ? "No users found for this filter"
                        : "No users available"}
                    </div>
                  )}
                </div>
              </Form.Group>

              <Form.Group controlId="courseSelect" className="mb-3">
                <Form.Label style={{ fontWeight: "500", fontSize: "0.9rem" }}>
                  Select Course
                </Form.Label>
                <Select
                  options={courseOptions}
                  value={selectedCourse}
                  onChange={setSelectedCourse}
                  isClearable
                  placeholder="Select a course"
                  menuPosition="fixed"
                  menuPlacement="auto"
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowModal(false)}
            disabled={isModalLoading}
            size="sm"
          >
            Cancel
          </Button>
          <Button
            onClick={handleAssign}
            className="btn-vetrina-primary"
            disabled={
              isModalLoading || !selectedUsers.length || !selectedCourse
            }
            size="sm"
          >
            {isModalLoading ? "Processing..." : editingId ? "Update" : "Assign"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CourseAssignment;